import * as R from "ramda";
import { TIME_PERIOD_ROLE, TIME_PERIOD_ID } from "./constants/dimensions.mjs";
const isTimePeriodDimension = R.anyPass([
  R.pipe(R.prop("role"), R.equals(TIME_PERIOD_ROLE)),
  R.propEq(TIME_PERIOD_ID, "id")
]);
export {
  isTimePeriodDimension
};
